module.exports = __webpack_public_path__ + "static/img/icon2.d1cdce92.png";